// extracted by mini-css-extract-plugin
export default {"header":"Search_header__XXXRf"};